import axios from "axios";
// 防止circle import
let vue = async () => {
    return (await import("../main")).vue;
};
let BaseUrl = "https://100feeling.cn/"
// BaseUrl = "http://192.168.31.146:9527/"
// BaseUrl = "http://10.23.172.10:9527/"

axios.defaults.baseURL = BaseUrl;

export let baseUrl = BaseUrl;

export function initRequestAuthorization(uid) {
    axios.defaults.headers.common["Authorization"] = uid;
}

if (!axios.interceptors.response.handlers.length) {
    axios.interceptors.response.use(resp => {
        if (resp.status >= 200 && resp.status < 300) {
            let data = resp.data;
            if (data.code == 0) {
                return data.data;
            } else {
                vue().then(e => e.$alert(data.error));
                // return data.error
                throw data.data;
            }
        } else {
            //error
        }
    });
}

export class HttpClient {
    static get(url, params = {}) {
        return axios.get(url, {
            params
        });
    }

    static post(url, body) {
        return axios.post(url, body);
    }

    static put(url, body) {
        return axios.put(url, body);
    }

    static delete(url, params) {
        return axios({
            url,
            params,
            method: "delete"
        });
    }
}
